// @ts-nocheck


import React from 'react';


import { TabItem, Tabs } from '../../../../components/ui';
import { budgetSummaryStatusEnum } from '../../../../lib/enum';







export default ({ id, orgUnitId, branchBudgetStatus }) => {
  return (
    <Tabs withRouter defaultTab={`/budget/summary/${id}/${orgUnitId}`}>
      <TabItem
        label={'Смета затрат'}
        key={'1'}
        url={`/budget/summary/${id}/${orgUnitId}`} />

      {branchBudgetStatus === budgetSummaryStatusEnum.approved &&
      <TabItem
        label={'Договоры'}
        key={'2'}
        url={`/budget/summary/${id}/${orgUnitId}/contracts`} />

      }
    </Tabs>);

};
